import React from "react";
import { Skeleton } from "app/components/Skeleton";

export const ProjectItemSkeleton: React.FC = () => (
  <div className="flex h-auto shrink-0 items-center justify-between gap-2.5 rounded border border-gray-100 px-4 py-3">
    {/* Left section */}
    <div className="flex items-center gap-2.5">
      <Skeleton className="size-[25px] rounded-[2.08px]" />
      <div className="flex flex-col gap-1">
        <Skeleton className="h-[20px] w-[100px] rounded" />
        <Skeleton className="h-[14px] w-[80px] rounded" />
      </div>
    </div>

    {/* Right section */}
    <div className="flex h-[58px] w-[215px] flex-col gap-2">
      {/* Developers Progress */}
      <div className="flex h-[25px] w-full flex-col justify-center">
        <Skeleton className="h-[10px] w-[80px] rounded mb-1" />
        <Skeleton className="h-[14px] w-full rounded" />
      </div>

      {/* QA Progress */}
      <div className="flex h-[25px] w-full flex-col justify-center">
        <Skeleton className="h-[10px] w-[60px] rounded mb-1" />
        <Skeleton className="h-[14px] w-full rounded" />
      </div>
    </div>
  </div>
);

export const ProjectsProgressWidgetSkeleton: React.FC = () => (
  <div className="flex flex-1 flex-col gap-4 overflow-y-auto pr-2">
    {[...Array(3)].map((_, i) => (
      <ProjectItemSkeleton key={i} />
    ))}
  </div>
);
